var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.19047 12.122L3.25297 8.18453C3.17087 8.10244 3.12476 7.9911 3.12476 7.875C3.12476 7.7589 3.17087 7.64756 3.25297 7.56547C3.33506 7.48338 3.4464 7.43726 3.5625 7.43726C3.6786 7.43726 3.78994 7.48338 3.87203 7.56547L7.0625 10.7565L7.0625 2.1875C7.0625 2.07147 7.10859 1.96019 7.19064 1.87814C7.27269 1.79609 7.38397 1.75 7.5 1.75C7.61603 1.75 7.72731 1.79609 7.80936 1.87814C7.89141 1.96019 7.9375 2.07147 7.9375 2.1875L7.9375 10.7565L11.128 7.56547C11.2101 7.48338 11.3214 7.43726 11.4375 7.43726C11.5536 7.43726 11.6649 7.48338 11.747 7.56547C11.8291 7.64756 11.8752 7.7589 11.8752 7.875C11.8752 7.9911 11.8291 8.10244 11.747 8.18453L7.80953 12.122C7.7689 12.1627 7.72065 12.195 7.66754 12.217C7.61442 12.239 7.55749 12.2503 7.5 12.2503C7.44251 12.2503 7.38558 12.239 7.33246 12.217C7.27935 12.195 7.2311 12.1627 7.19047 12.122Z",
    fill: "#7C63A4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.39821065b6877c27fb5406b05c5cfc36.svg";
export { ForwardRef as ReactComponent };